<template>
  <div class="evaluat_user-root org_eval_show-root">
    <div class="avator">
      <img
        class="img"
        :src="isImgLoadErr ? $options._myOpt.momentCover:classInfo.moment_picture"
        @error="isImgLoadErr = true"
      >
    </div>
    <div class="info">
      <p  v-if="classInfo.class_level==='C' || classInfo.class_level ==='D' ">培训日期：{{classInfo.start_date | time(false)}} 至 {{classInfo.end_date | time(false)}}</p>
        <div style="display: flex;align-items: center" v-if="classInfo.class_level==='A' || classInfo.class_level ==='B' ">
          <p>培训第一阶段：{{dataPhase.start_date | time(false)}} 至 {{dataPhase.end_date | time(false)}}</p>
          <p style="margin-left: 30px ">培训第二阶段：{{dataPhase.start_date1 | time(false)}} 至 {{dataPhase.end_date1 | time(false)}}</p>
        </div>
      <p>训练场地：{{classInfo.training_address}}</p>
      <p>理论课场地：{{classInfo.theory_address}}</p>
      <p>
        <span>主讲师：{{classInfo.teacher_off_name}}</span>
        <span> &nbsp;&nbsp;&nbsp;&nbsp; </span>
        <span v-if="classInfo.teacher_name">助理讲师：{{classInfo.teacher_name}}</span>
        <span> &nbsp;&nbsp;&nbsp;&nbsp; </span>
        <span v-if="classInfo.lecturer_assistant_name">讲师助理：{{classInfo.lecturer_assistant_name}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import momentCover from "@/assets/images/class_logo.png";

export default {
  name: "OrgEvaluatUser",
  _myOpt: {
    momentCover
  },
  props: {
    classInfo: {
      type: Object,
      required: true
    },
    dataPhase:{
      type: Object,
      required: false
    }
  },
  data() {
    return {
      isImgLoadErr: false
    };
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluatUserShow'
</style>
